import { RollbackOutlined, SaveOutlined, UnlockOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const ContactActionBar = ({
  formInstance,
  isFormReadOnly,
  isFormSubmitting,
  setFormEditable,
  setFormDisabled,
  setDeletingModalOpen,
}) => {
  const { t } = useTranslation();
  return (
    <Space style={{ float: "right" }}>
      {isFormReadOnly ? (
        <Button icon={<UnlockOutlined />} onClick={setFormEditable}>
          {t("common.allowChanges")}
        </Button>
      ) : (
        <React.Fragment>
          <Button
            danger
            onClick={() => {
              setDeletingModalOpen(true);
            }}
          >
            {t("common.delete")}
          </Button>

          <Button
            icon={<RollbackOutlined />}
            onClick={() => {
              formInstance.resetFields();
              setFormDisabled();
            }}
          >
            {t("common.discardChanges")}
          </Button>
          <Button
            loading={isFormSubmitting}
            icon={<SaveOutlined />}
            onClick={() => {
              formInstance.submit();
            }}
          >
            {t("common.saveChanges")}
          </Button>
        </React.Fragment>
      )}
    </Space>
  );
};

export default ContactActionBar;
